// import { DocumentTypeAttribute } from "../../projectConfig/models/DocumentType";

export class GeneralUtils {

  static isEmpty(value: any): boolean {
    if (value === null || value == undefined || value === "") return true;
    if (typeof value === "string" || Array.isArray(value)) return value.length === 0;
    if (typeof value === "object") return Object.keys(value).length === 0;
    return false;
  }

  static isAlphaNumeric(input: string): boolean {
    const pattern = /^[a-zA-Z0-9]*$/;
    return pattern.test(input);
  }

  static getAdjustedClientHeight(element: HTMLElement): number {
    if (!element) return 0;

    const style = window.getComputedStyle(element);
    const clientHeight = element.clientHeight;
    const borderTop = parseFloat(style.borderTopWidth) || 0;
    const borderBottom = parseFloat(style.borderBottomWidth) || 0;
    const marginTop = parseFloat(style.marginTop) || 0;
    const marginBottom = parseFloat(style.marginBottom) || 0;

    const totalHeight = clientHeight + borderTop + borderBottom + marginTop + marginBottom;
    return totalHeight;
  }

  static getFieldLength(fieldNumber: number): string {
    const fieldClassTypesMap: { [key: number]: string } = {
      1: 'matInputSingle',
      2: 'matInputDouble',
      3: 'matInputTripple',
      4: 'matInputFour',
      5: 'matInputFive'
    };
    const result = fieldClassTypesMap[fieldNumber] || 'matInputSingle';
    return result;
  }

  // static getAttributeTitleOrName(attr: DocumentTypeAttribute): string {
  //   if (attr.title && attr.title != "") return attr.title;
  //   return attr.name;
  // }

   public static toComfortableUrlString(rawUrl: string): string {  
       // e.g. "https://db2.wpsquirrel.de" ==> "DB2_WPSQUIRREL"  
       let ret = rawUrl;  
       const posLastDot = ret.lastIndexOf(".");  
       if (posLastDot >= 0) {  
           ret = ret.substring(0, posLastDot);  
       }  
       const posDoubleSlash = ret.indexOf("//");  
       if (posDoubleSlash >= 0) {  
           ret = ret.substring(posDoubleSlash + 2);  
       }  
       ret = ret.replace(/\./g, "_");  
       ret = ret.toUpperCase();  
       return ret;  
   }  

   public static toComfortableTenantName(rawTenant: string): string {  
       // e.g. "DB InfraGo AG" ==> "DB_INFRAGO_AG"  
       let ret = rawTenant;  
       ret = ret.replace(/ /g, "_");  
       ret = ret.toUpperCase();  
       return ret;  
   }  

    public static generateGuid(): string {  
   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {  
       const r = (Math.random() * 16) | 0,  
             v = c === 'x' ? r : (r & 0x3) | 0x8;  
       return v.toString(16);  
   });  
  }
}
